import config from '../../config/config';

import getRequest from './base/get';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  fetchPayments: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/wallet-history`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination version 2
   * @param {any} query - The query
   */
  fetchPaymentsV2: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.reportApiUrl}api/super-admin/v2/charging-transaction`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  fetchUsers: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction/list-charging-transactions`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Accounts list with pagination
   * @param {any} data - The data
   */
  fetchChargingSessionsListFilters: (data: QueryParameters = {}): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/charging-transaction/list-filters`, data),
  /**
   * Fetch charging sessions
   * @param {any} query - The query
   */
  fetchChargingSessions: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v2/charging-transaction/list-all-charging-transactions`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch personal charging sessions
   * @param {any} query - The query
   */
  fetchPersonalChargingSessions: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v2/charging-transaction/list-all-personal-charging-transactions`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchPaymentsListFilters: (): Promise<any> =>
    getRequest(`${config.transactionApiUrl}api/super-admin/v1/wallet-history/list-filters`),

  /**
   * Fetch the Accounts list export
   * @param {any} query - The query
   */
  fetchPaymentsExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/wallet-history/export-data`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list export version 2
   * @param {any} query - The query
   */
  fetchPaymentsExportV2: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.reportApiUrl}api/super-admin/v2/charging-transaction/export-data`, {
      ...parameters,
    });
  },
  /**
   * Fetch the transaction list for export
   * @param {any} query - The query
   */
  fetchTransactionExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/facility/list-charging-transactions/export-data`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch approved station API
   * @returns {any} A promise that resolves with the list filters
   */
  fetchListFilters: () => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-transaction/list-filters`);
  },
};
